export default __webpack_public_path__ + "static/media/BackgroundLeaves.e9433cca.jpeg";